module.exports = __webpack_public_path__ + "img/plavix_banner.6402ed5c.jpg";